import * as React from 'react'
import type { ICloseRequirements } from '@user/store/opportunity'
import {
  AgreementIcon,
  LocationIcon,
  ScheduleIcon,
  PaymentIconV2,
  ServiceIconV2,
} from '@sales-center/components'

type Props = Pick<ICloseRequirements, 'type'>

export const ReasonIcon = (props: Props) => {
  switch (props.type) {
    case 'Agreement Signature':
    case 'Agreements':
      return <AgreementIcon />
    case 'Location':
      return <LocationIcon />
    case 'Payment':
      return <PaymentIconV2 />
    case 'Products':
      return <ServiceIconV2 />
    case 'Free Estimate':
    case 'Paid Estimate':
    case 'Service Scheduled':
      return <ScheduleIcon />
  }
}
